import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Goapackagesfrompuneforfamily() {



const cardData =
{
  keyword: 'Goa Packages from Pune for Family',

  heading: 'Lotus Cab: Goa Packages from Pune for Family ',

headingDescription:
  "Lotus Cabs offers customized Goa Packages from Pune for Family, designed to provide a comfortable, safe, and memorable holiday experience. Our family-friendly tour packages include convenient cab travel, flexible sightseeing options, and hassle-free transportation from Pune to Goa. Whether you are planning a beach vacation, family getaway, sightseeing tour, or relaxing holiday, our premium fleet of Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus ensures a comfortable journey. With professional and experienced chauffeurs, 24x7 booking support, transparent pricing, doorstep pickup from any location in Pune, well-maintained vehicles, and smooth highway travel, Lotus Cabs makes your Goa family trip enjoyable and stress-free.",

  top: 'Top Places to Visit in Goa before Traveling to Pune with Lotus Cab',

topPlaces: [
   
    {
        title: "Cabo de Rama Fort",
        description:
            "Cabo de Rama Fort is a historic fort located on a cliff overlooking the Arabian Sea. Famous for its spectacular ocean views, ancient architecture, and peaceful surroundings, it is an excellent destination for history lovers and sunset photography."
    },
     {
        title: "Grand Island",
        description:
            "Grand Island is one of Goa's most popular adventure destinations, famous for snorkeling, scuba diving, fishing, and exploring vibrant marine life. Surrounded by crystal-clear waters of the Arabian Sea, the island offers an exciting experience for adventure seekers and nature lovers."
    },
     {
        title: "Betul Beach",
        description:
            "Betul Beach is a quiet fishing village beach in South Goa known for its serene coastline, traditional seafood, and beautiful sunset views. The peaceful surroundings make it perfect for travelers looking to experience authentic Goan culture."
    },
    {
        title: "Netravali Wildlife Sanctuary",
        description:
            "Netravali Wildlife Sanctuary is a hidden gem in South Goa, famous for lush green forests, waterfalls, trekking routes, and rich biodiversity. The sanctuary offers a refreshing experience for travelers interested in nature, photography, and wildlife exploration."
    },
    {
        title: "Cotigao Wildlife Sanctuary",
        description:
            "Cotigao Wildlife Sanctuary is one of Goa's oldest wildlife reserves, known for dense forests, diverse wildlife, and beautiful natural landscapes. Visitors can explore walking trails, spot animals and birds, and enjoy the peaceful environment away from crowded tourist areas."
    },
     {
        title: "Kakolem Beach",
        description:
            "Kakolem Beach, also known as Tiger Beach, is a secluded coastal paradise surrounded by cliffs and greenery. Its untouched beauty, peaceful atmosphere, and scenic views make it one of Goa's best offbeat beach destinations."
    },
    {
        title: "Salaulim Dam",
        description:
            "Salaulim Dam is a scenic attraction surrounded by lush greenery and natural landscapes. The unique spillway design, peaceful reservoir, and beautiful gardens make it a relaxing destination for families and nature enthusiasts."
    },
    {
        title: "Hollant Beach",
        description:
            "Hollant Beach is a calm and less crowded beach near Vasco da Gama, known for its shallow waters, peaceful environment, and stunning sunrise views. It is an ideal spot for swimming, photography, and enjoying a relaxing coastal experience."
    },
    {
        title: "Kesarval Spring",
        description:
            "Kesarval Spring is a natural spring near Cortalim known for its scenic surroundings and traditional importance. Surrounded by greenery, the location offers visitors a peaceful escape and a chance to explore Goa's natural attractions."
    },
    {
        title: "Palácio do Deão",
        description:
            "Palácio do Deão is a historic Portuguese-style heritage mansion located in Quepem, Goa. Known for its beautiful architecture, riverside gardens, and cultural significance, the palace offers visitors a glimpse into Goa's colonial-era lifestyle and traditions."
    }
],





"services": [
  {
    "name": "Goa Packages from Pune for Family",
    "description": "Book Goa packages from Pune for family and enjoy a memorable beach vacation with comfortable cab transportation and customized travel itineraries. These packages are specially designed for families looking for a relaxing holiday with sightseeing, beach visits, and convenient travel arrangements. Choose from sedan, Ertiga, and Innova vehicles with experienced drivers and flexible schedules for a hassle-free family trip."
  },
  {
    "name": "Goa Family Packages from Pune",
    "description": "Goa family packages from Pune offer complete travel solutions for families planning a fun and relaxing vacation. The package includes private cab services, comfortable accommodation options, and sightseeing opportunities across North and South Goa. Spacious vehicles and professional chauffeurs ensure a smooth and enjoyable journey for all age groups."
  },
  {
    "name": "Pune to Goa Family Package",
    "description": "Pune to Goa family package is ideal for families looking to spend quality time together at Goa's beautiful beaches and tourist destinations. The package includes comfortable transportation, flexible itineraries, and personalized travel plans. Families can enjoy sightseeing, local attractions, and a stress-free road trip with professional drivers."
  },
  {
    "name": "Pune to Goa Tour Package for Family",
    "description": "Book Pune to Goa tour package for family and experience a perfectly planned vacation with comfortable travel arrangements and sightseeing options. The package is suitable for small and large families, offering spacious vehicles, flexible schedules, and enough time to explore beaches, churches, forts, and local markets."
  },
  {
    "name": "Pune to Goa Family Cab Package",
    "description": "Pune to Goa family cab package provides private transportation with comfortable AC vehicles for a convenient and enjoyable road trip. Families can choose from Ertiga, Innova Crysta, and SUV options based on group size and luggage requirements. Ideal for holidays, weekend trips, and extended vacations."
  },
  {
    "name": "Pune to Goa Holiday Package",
    "description": "Enjoy a memorable vacation with Pune to Goa holiday package featuring comfortable cab services and customized travel plans. The package allows families to explore Goa's famous beaches, water sports activities, churches, and tourist attractions while enjoying the convenience of private transportation and flexible itineraries."
  },
  {
    "name": "Pune to Goa Vacation Package",
    "description": "Pune to Goa vacation package is designed for travelers seeking a relaxing and enjoyable holiday with family and friends. The package includes comfortable transportation, sightseeing opportunities, and personalized travel schedules. Spacious vehicles and experienced drivers ensure a safe and memorable trip to Goa."
  },
  {
    "name": "Pune to Goa Sightseeing Package",
    "description": "Book Pune to Goa sightseeing package and discover the best of North and South Goa with private cab transportation. The package includes visits to famous beaches, forts, churches, local markets, and popular tourist attractions. Ideal for families wanting a convenient and personalized travel experience."
  },
  {
    "name": "Pune to Goa Family Taxi Package",
    "description": "Pune to Goa family taxi package offers a comfortable and economical travel solution for families planning a beach vacation. The package includes spacious vehicles, professional chauffeurs, and flexible itineraries to ensure a stress-free and enjoyable holiday experience."
  },
  {
    "name": "Pune to Goa Weekend Family Tour",
    "description": "Pune to Goa weekend family tour is perfect for short holidays and long weekends. Families can enjoy comfortable road travel, personalized sightseeing, and flexible tour plans that cover Goa's major attractions. The package is designed to maximize relaxation and family time during a quick getaway."
  },
  {
    "name": "Pune to Goa 2 Days Family Package",
    "description": "Pune to Goa 2 days family package is ideal for families looking for a short beach vacation with convenient transportation and sightseeing opportunities. The package includes private cab services, comfortable travel arrangements, and enough time to enjoy Goa's scenic beauty and popular attractions."
  },
  {
    "name": "Pune to Goa 3 Days Family Package",
    "description": "Enjoy a relaxing holiday with Pune to Goa 3 days family package that provides comfortable cab transportation and a well-planned itinerary. Families can explore beaches, local markets, and historical sites while enjoying spacious vehicles and flexible travel schedules throughout the trip."
  },
  {
    "name": "Best Goa Packages from Pune for Family",
    "description": "Best Goa packages from Pune for family offer a perfect combination of comfortable transportation, sightseeing, and personalized travel plans. These packages are designed to provide a memorable holiday experience with professional drivers, spacious vehicles, and customized itineraries suitable for all family members."
  },
  {
    "name": "Affordable Goa Family Package from Pune",
    "description": "Affordable Goa family package from Pune provides budget-friendly travel options without compromising comfort and convenience. Families can enjoy private cab transportation, flexible travel plans, and sightseeing opportunities at competitive prices, making it an excellent choice for a memorable family vacation."
  }
],

"tableData": [
  ["Goa Packages from Pune for Family", "Goa Family Packages from Pune"],
  ["Pune to Goa Family Package", "Pune to Goa Tour Package for Family"],
  ["Pune to Goa Family Cab Package", "Pune to Goa Holiday Package"],
  ["Pune to Goa Vacation Package", "Pune to Goa Sightseeing Package"],
  ["Pune to Goa Family Taxi Package", "Pune to Goa Weekend Family Tour"],
  ["Pune to Goa 2 Days Family Package", "Pune to Goa 3 Days Family Package"],
  ["Best Goa Packages from Pune for Family", "Affordable Goa Family Package from Pune"]
],






"whychoose": [
  {
    "WhyChooseheading": "Special Family Vacation Packages",
    "WhyChoosedescription": "Enjoy memorable Goa holidays with customized family packages starting from Pune."
  },
  {
    "WhyChooseheading": "Spacious Family Vehicles",
    "WhyChoosedescription": "Choose comfortable Ertiga, Innova Crysta, and SUV cabs with ample seating and luggage space."
  },
  {
    "WhyChooseheading": "Customized Travel Plans",
    "WhyChoosedescription": "Plan your Goa trip according to your family's schedule, sightseeing preferences, and stay duration."
  },
  {
    "WhyChooseheading": "Budget-Friendly Tour Options",
    "WhyChoosedescription": "Affordable family packages with transparent pricing and no hidden charges."
  },
  {
    "WhyChooseheading": "Doorstep Pickup from Pune",
    "WhyChoosedescription": "Convenient pickup services from homes, hotels, airports, and railway stations in Pune."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Experienced drivers ensure a smooth and secure journey for children, adults, and senior citizens."
  },
  {
    "WhyChooseheading": "Flexible Trip Duration",
    "WhyChoosedescription": "Book weekend getaways, 2-day, 3-day, or extended Goa family vacation packages."
  },
  {
    "WhyChooseheading": "24/7 Booking Assistance",
    "WhyChoosedescription": "Our support team is always available to help with package details and reservations."
  }
]
};

const faqData = [
  {
    question: 'Does Lotus Cab provide Goa packages from Pune for families?',
    answer: 'Yes, Lotus Cab offers customized Goa tour packages from Pune specially designed for families, couples, and groups.'
  },
  {
    question: 'Which vehicles are available for family packages?',
    answer: 'We provide Ertiga, Innova Crysta, and spacious SUVs that are ideal for family vacations and group travel.'
  },
  {
    question: 'What is the distance between Pune and Goa?',
    answer: 'The road distance from Pune to Goa is approximately 450 km, and the journey usually takes around 8 to 10 hours.'
  },
  {
    question: 'Can I customize my family tour package?',
    answer: 'Yes, our Goa packages can be customized according to your travel dates, sightseeing plans, and duration of stay.'
  },
  {
    question: 'Are one-way and round-trip packages available?',
    answer: 'Yes, Lotus Cab offers both one-way and round-trip family packages from Pune to Goa.'
  },
  {
    question: 'Do you provide pickup from home in Pune?',
    answer: 'Yes, we offer doorstep pickup services from residential areas, hotels, offices, airports, and railway stations.'
  },
  {
    question: 'Are toll and parking charges included in the package?',
    answer: 'Toll charges, parking fees, and state taxes are generally charged separately unless specifically included in the package quotation.'
  },
  {
    question: 'Is the package suitable for senior citizens and children?',
    answer: 'Absolutely. Our spacious vehicles and experienced drivers ensure a comfortable and safe journey for all age groups.'
  },
  {
    question: 'Can I book a multi-day family vacation package to Goa?',
    answer: 'Yes, we offer 2-day, 3-day, and extended family holiday packages according to your requirements.'
  },
  {
    question: 'How can I book Goa Packages from Pune for Family with Lotus Cab?',
    answer: 'Simply share your travel date, number of family members, pickup location, and preferred vehicle to receive package details and instant confirmation.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Mahesh Kulkarni',
    feedback: 'Planning a family vacation can be challenging, but Lotus Cab made everything simple. The spacious vehicle and comfortable ride allowed us to enjoy every moment of our Goa trip.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Nandini Patil',
    feedback: 'Our children and parents were traveling together, so comfort was very important. The family package was well organized, and the entire journey to Goa was enjoyable and stress-free.',
    rating: 5,
  },
];







































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Goa Packages from Pune for Family",
"image": "https://lotuscab.com/assets/images/goa-packages-from-pune-for-family.jpg",
"description": "Book Goa Packages from Pune for Family with Lotus Cab for a comfortable and memorable holiday experience. Enjoy family tour packages, sightseeing trips, vacation packages, and private cab services from Pune to Goa with professional drivers and premium AC taxis available 24x7.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7215"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/goa-packages-from-pune-for-family"
}
};






  return (
    <div>
      

<Helmet>
  <title>Goa Packages from Pune for Family | Family Tour Package by Cab | +91 8767592195</title>

<meta
 name="description"
 content="Book Goa Packages from Pune for Family with Lotus Cab. Enjoy affordable family holiday packages, sightseeing tours, vacation trips, and private cab packages from Pune to Goa with comfortable AC taxis and professional drivers."
/>

<meta
 name="keywords"
 content="Goa Packages from Pune for Family, Goa Family Packages from Pune, Pune to Goa Family Package, Pune to Goa Tour Package for Family, Pune to Goa Family Cab Package, Pune to Goa Holiday Package, Pune to Goa Vacation Package, Pune to Goa Sightseeing Package, Pune to Goa Family Taxi Package, Pune to Goa Weekend Family Tour, Pune to Goa 2 Days Family Package, Pune to Goa 3 Days Family Package, Best Goa Packages from Pune for Family, Affordable Goa Family Package"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/107.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Goapackagesfrompuneforfamily;